export default {
  // Page titles
  title: 'สัญญาเช่า',
  new_lease: 'สร้างสัญญาเช่า',
  edit_lease: 'แก้ไขสัญญาเช่า',
  lease_detail: 'รายละเอียดสัญญาเช่า',

  // Descriptions
  description: 'จัดการสัญญาเช่า',
  new_description: 'สร้างสัญญาเช่าใหม่',
  edit_description: 'แก้ไขรายละเอียดสัญญาเช่า',

  // Labels
  labels: {
    lease_code: 'รหัสสัญญา',
    customer: 'ลูกค้า',
    unit: 'ห้อง',
    property: 'อสังหาริมทรัพย์',
    start_date: 'วันที่เริ่ม',
    end_date: 'วันที่สิ้นสุด',
    end_date_optional: 'วันที่สิ้นสุด (ไม่บังคับ)',
    deposit: 'เงินประกัน',
    // EP-156 (T156-010, §3.3) — two optional, invoicing-independent charges.
    move_in_fee: 'ค่าแรกเข้า',
    keycard_deposit: 'เงินมัดจำคีย์การ์ด',
    monthly_rent: 'ค่าเช่ารายเดือน',
    rent: 'ค่าเช่า',
    // F10/AC-8 (EP-158): the unit/rent amount used to be suffixed with the
    // hardcoded English "/mo" on Thai screens.
    per_month: '/เดือน',
    pinned_at_activation: 'ตรึงไว้',
    status: 'สถานะ',
    signed_at: 'ลงนามเมื่อ',
    tenant: 'ผู้เช่า',
    phone: 'โทรศัพท์',
    id_card: 'บัตรประชาชน',
    address: 'ที่อยู่',
  },

  // Placeholders
  placeholders: {
    select_customer: 'เลือกลูกค้า',
    select_property: 'เลือกอสังหาริมทรัพย์',
    select_unit: 'เลือกห้อง',
    search_customers: 'ค้นหาลูกค้า...',
    search_properties: 'ค้นหาอสังหาริมทรัพย์...',
    // EP-156 (T156-010): ฿200 is only the key-card placeholder, not a default.
    keycard_deposit_example: 'เช่น 200',
  },

  // Status
  status: {
    draft: 'ร่าง',
    pending_signatures: 'รอลงนาม',
    pending_start: 'รอเริ่มสัญญา',
    active: 'ใช้งาน',
    pending: 'รอดำเนินการ',
    ended: 'สิ้นสุด',
    all: 'ทุกสถานะ',
    // EP-97: default live roster (active + pending_start + pending_signatures).
    live_default: 'สัญญาที่ใช้งานอยู่',
    showing_live: 'กำลังแสดงสัญญาที่ใช้งานอยู่',
  },

  // Signatures
  signatures: {
    title: 'ลายเซ็น',
    landlord: 'ลายเซ็นผู้ให้เช่า',
    tenant: 'ลายเซ็นผู้เช่า',
    sign_lease: 'ลงนามสัญญา',
    complete_signing: 'ลงนามเสร็จสิ้น',
    sign_info: 'ผู้ให้เช่าและผู้เช่าต้องลงนามทั้งคู่เพื่อทำสัญญาให้เสร็จสมบูรณ์',
    both_captured: 'บันทึกลายเซ็นทั้งสองฝ่ายแล้ว พร้อมลงนาม',
    signed_on: 'ลงนามเมื่อ {{date}}',
  },

  // Actions
  actions: {
    add_lease: 'สร้างสัญญาเช่า',
    create_lease: 'สร้างสัญญาเช่า',
    activate: 'เปิดใช้งาน',
    activate_lease: 'เปิดใช้งานสัญญา',
    end_lease: 'สิ้นสุดสัญญา',
    download_pdf: 'ดาวน์โหลด PDF',
    generate_pdf: 'สร้าง PDF',
    preview_pdf: 'ดูตัวอย่าง PDF',
    generate_sign_links: 'สร้างลิงก์ลงนาม',
    copy_link: 'คัดลอกลิงก์',
    bill_deposit: 'เรียกเก็บเงินประกัน',
    renew_lease: 'ต่อสัญญา',
  },

  // Empty states
  empty: {
    title: 'ไม่พบสัญญาเช่า',
    description: 'เริ่มต้นด้วยการสร้างสัญญาเช่าแรก',
    no_vacant_units: 'ไม่มีห้องว่างในอสังหาริมทรัพย์นี้',
  },

  // Setup guide
  setup_guide: {
    title: 'ยินดีต้อนรับสู่สัญญาเช่า',
    description:
      'สัญญาเช่าเชื่อมต่อลูกค้ากับห้อง ก่อนสร้างสัญญาเช่า ตรวจสอบให้แน่ใจว่ามีอสังหาริมทรัพย์พร้อมห้องและลูกค้าอย่างน้อยหนึ่งราย',
    prerequisites_title: 'ก่อนเริ่มต้น',
    prereq_property: 'อสังหาริมทรัพย์พร้อมห้องอย่างน้อยหนึ่งแห่ง',
    prereq_customer: 'ลูกค้าอย่างน้อยหนึ่งราย',
    prereq_setup_property: 'ตั้งค่า',
    prereq_add_customer: 'เพิ่ม',
    step_1_title: 'เลือกห้อง',
    step_1_description: 'เลือกห้องว่างจากอสังหาริมทรัพย์ของคุณ',
    step_2_title: 'เลือกลูกค้า',
    step_2_description: 'เลือกผู้เช่าที่จะเช่าห้อง',
    step_3_title: 'กำหนดวันที่และเงินประกัน',
    step_3_description:
      'กำหนดวันเริ่มต้น วันสิ้นสุด (ไม่บังคับ) และจำนวนเงินประกัน',
    import: 'นำเข้าจากไฟล์',
    import_off_scope_warning: 'พบ {{count}} แถว {{entity}} นำเข้าจากหน้า {{Entity}}',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'เพิ่มข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ระบบจะสร้าง: อสังหาริมทรัพย์ + ห้อง + ลูกค้า + สัญญาเช่า 1 รายการ ต้องการดำเนินการต่อหรือไม่?',
    seed_sample_success: 'สร้างข้อมูลตัวอย่าง (อสังหาริมทรัพย์ ห้อง ลูกค้า สัญญาเช่า) สำเร็จ',
    seed_sample_noop: 'มีสัญญาเช่าอยู่แล้ว ไม่ได้เพิ่มข้อมูลตัวอย่าง',
  },

  // Filters
  filters: {
    search_placeholder: 'ค้นหารหัสสัญญาหรือเลขห้อง...',
  },

  // Sign links modal
  sign_modal: {
    title: 'ตั้งค่าผู้ลงนาม',
    tenant_name: 'ชื่อผู้เช่า',
    owner_name: 'ชื่อเจ้าของ / ผู้ให้เช่า',
    witness_1: 'พยานคนที่ 1 (ไม่บังคับ)',
    witness_2: 'พยานคนที่ 2 (ไม่บังคับ)',
    generate: 'สร้างลิงก์ลงนาม',
    default_tenant_name: 'ผู้เช่า',
    default_owner_name: 'เจ้าของ',
    default_witness_1_name: 'พยานคนที่ 1',
    default_witness_2_name: 'พยานคนที่ 2',
  },

  // Signature panel
  signature_panel: {
    title: 'ลายเซ็น',
    signed: 'ลงนามแล้ว',
    unsigned: 'ยังไม่ลงนาม',
    expired: 'หมดอายุ',
    expires_at: 'หมดอายุ {{date}}',
    all_signed: 'ทุกฝ่ายลงนามแล้ว',
    copy_link: 'คัดลอกลิงก์',
    link_copied: 'คัดลอกลิงก์แล้ว!',
    regenerate: 'สร้างใหม่',
    regenerate_title: 'สร้างลิงก์ลงนามใหม่',
    signer_name: 'ชื่อผู้ลงนาม',
    expires_in_hours: 'หมดอายุใน (ชั่วโมง)',
  },

  // Form section headings (EP-86 S2: Essentials/Advanced regroup)
  sections: {
    essentials: 'ข้อมูลหลัก',
    advanced_options: 'ตัวเลือกขั้นสูง',
    terms: 'เงื่อนไข',
    documents: 'เอกสาร',
  },

  // Attachments section
  attachments: {
    title: 'ไฟล์แนบ',
    images_section: 'รูปภาพ',
    files_section: 'ไฟล์',
    upload_image: 'อัปโหลดรูปภาพ',
    upload_file: 'อัปโหลดไฟล์',
  },

  // EP-160 T160-104x: ปิดศาสนาและหมู่เลือดบนสำเนาบัตรประชาชน
  id_copy: {
    checkbox: 'นี่คือสำเนาบัตรประชาชน',
    images_only_hint: 'ปิดข้อมูลได้เฉพาะไฟล์ภาพ (JPEG, PNG, WebP) ส่วนเอกสารจะอัปโหลดตามเดิม',
    not_supported: 'ปิดข้อมูลได้เฉพาะภาพ JPEG, PNG และ WebP ยกเลิกเครื่องหมาย "นี่คือสำเนาบัตรประชาชน" หากต้องการอัปโหลดไฟล์นี้ตามเดิม',
    title: 'ปิดศาสนาและหมู่เลือด',
    instructions: 'ลากกล่องสีดำไปวางทับบรรทัดศาสนาและหมู่เลือด ปรับขนาดที่มุมกล่อง หรือใช้ปุ่มลูกศร (กด Shift ค้างเพื่อปรับขนาด) ระบบจะอัปโหลดเฉพาะภาพที่ปิดแล้ว',
    preview_alt: 'สำเนาบัตรประชาชน',
    box_label: 'กล่องสีดำ {{number}}',
    remove_box: 'ลบกล่องสีดำ {{number}}',
    add_box: 'เพิ่มกล่อง',
    use_blacked_out: 'ใช้ภาพที่ปิดแล้ว',
    failed: 'อ่านหรือบันทึกภาพไม่สำเร็จ ลองใช้ภาพอื่น',
  },

  // Sign page (public signing page)
  sign_page: {
    title: 'สัญญาเช่า',
    lease_signing: 'ลงนามสัญญาเช่า',
    lease_details: 'รายละเอียดสัญญา',
    labels: {
      property: 'อสังหาริมทรัพย์',
      unit: 'ห้อง',
      tenant: 'ผู้เช่า',
      period: 'ระยะเวลา',
      rent: 'ค่าเช่ารายเดือน',
      deposit: 'เงินประกัน',
      // EP-156 (T156-009/T156-010, §3.3/S9) — shown only when set.
      move_in_fee: 'ค่าแรกเข้า',
      keycard_deposit: 'เงินมัดจำคีย์การ์ด',
    },
    signing_as: 'ลงนามในนาม',
    your_signature: 'ลายเซ็นของคุณ',
    draw_instruction: 'วาดลายเซ็นในช่องด้านล่างโดยใช้นิ้วหรือเมาส์',
    clear: 'ล้าง',
    submit_signature: 'ส่งลายเซ็น',
    agree_terms: 'การส่งลายเซ็นถือว่าคุณยอมรับเงื่อนไขสัญญาเช่า',
    states: {
      success_title: 'ส่งลายเซ็นแล้ว',
      success_message: 'บันทึกลายเซ็นของคุณเรียบร้อยแล้ว',
      all_signed: 'ทุกฝ่ายลงนามแล้ว สัญญาเช่าสมบูรณ์',
      waiting_others: 'รอฝ่ายอื่นลงนาม',
      already_signed_title: 'ลงนามแล้ว',
      already_signed_message: 'คุณได้ลงนามในสัญญาเช่านี้แล้ว',
      signed_on: 'ลงนามเมื่อ {{date}}',
      expired_title: 'ลิงก์หมดอายุ',
      expired_message: 'ลิงก์ลงนามนี้หมดอายุแล้ว กรุณาติดต่อผู้จัดการอสังหาริมทรัพย์เพื่อขอลิงก์ใหม่',
      invalid_title: 'ลิงก์ไม่ถูกต้อง',
      invalid_message:
        'ลิงก์ลงนามนี้ไม่ถูกต้อง กรุณาติดต่อผู้จัดการอสังหาริมทรัพย์เพื่อขอลิงก์ใหม่',
    },
    errors: {
      generic: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      network: 'เกิดข้อผิดพลาดเครือข่าย กรุณาตรวจสอบการเชื่อมต่อและลองอีกครั้ง',
      changed: 'สัญญานี้เพิ่งถูกอัปเดตโดยผู้ลงนามอีกคน กรุณากดลงนามอีกครั้ง ลายเซ็นของคุณยังอยู่',
    },
  },

  // Messages
  messages: {
    delete_confirm: 'ลบสัญญาเช่านี้? การกระทำนี้ไม่สามารถยกเลิกได้',
    delete_title: 'ลบสัญญาเช่า',
    end_confirm: 'สิ้นสุดสัญญาเช่านี้? สัญญาจะถูกเปลี่ยนสถานะเป็นสิ้นสุด',
    // EP-156 (T156-010, §3.3/S7) — shown only when the lease has no renewal
    // (has_renewal === false) and at least one of ค่าแรกเข้า/เงินมัดจำคีย์การ์ด
    // is set; a missing or true has_renewal falls back to end_confirm above.
    end_confirm_with_expense: 'สิ้นสุดสัญญาเช่านี้? สัญญาจะถูกเปลี่ยนสถานะเป็นสิ้นสุด และจะสร้างค่าใช้จ่าย {{amount}} (คืนค่าแรกเข้า + เงินมัดจำคีย์การ์ด)',
    end_success: 'สิ้นสุดสัญญาแล้ว',
    end_success_with_expense: 'สิ้นสุดสัญญาแล้ว · สร้างค่าใช้จ่ายรอยืนยันแล้ว',
    // EP-162 item 11 follow-up 1: Renew creates a draft lease for the same room and tenant.
    renew_confirm: 'ต่อสัญญานี้? ระบบจะสร้างสัญญาฉบับร่างใหม่สำหรับห้องและผู้เช่าเดิม ค่าเช่าและเงินประกันเท่าเดิม แก้ไขได้ก่อนลงนาม',
    renew_success: 'สร้างสัญญาต่ออายุเป็นฉบับร่างแล้ว',
    creating: 'กำลังสร้างสัญญาเช่าและสร้าง PDF...',
    created: 'สร้างสัญญาเช่าสำเร็จ',
    updated: 'แก้ไขสัญญาเช่าสำเร็จ',
    deleted: 'ลบสัญญาเช่าสำเร็จ',
    signed: 'ลงนามสัญญาเช่าสำเร็จ',
    pdf_regenerated: 'ไม่พบไฟล์ PDF ที่จัดเก็บไว้ ระบบจึงสร้างใหม่จากเทมเพลตสัญญาเช่า ลายเซ็นที่เคยอยู่ในไฟล์เดิมไม่สามารถกู้คืนได้',
    not_found: 'ไม่พบสัญญาเช่า',
    ongoing: 'ต่อเนื่อง',
    unknown: 'ไม่ทราบ',
    per_month: '/เดือน',
    property_default: 'ค่าเริ่มต้นของอสังหาริมทรัพย์: {{hint}}',
    deposit_months: '{{count}} เดือนของค่าเช่า',
    deposit_fixed: '฿{{amount}} คงที่',
    detail_description: 'สัญญาเช่าเริ่มต้น {{date}}',
    back_to_leases: 'กลับไปสัญญาเช่า',
    no_lease_template: 'ไม่พบเทมเพลตสัญญาเช่า กรุณาตั้งค่าใน "ตั้งค่า → เทมเพลต"',
    preview_requires_fields: 'เลือกห้อง ลูกค้า และวันที่เริ่มสัญญา เพื่อดูตัวอย่าง PDF',
  },

  // Top-level error messages
  errors: {
    lease_template_missing: 'ไม่พบเทมเพลตเอกสารสัญญาเช่า กรุณาตั้งค่าเทมเพลตสัญญาเช่าในเมนู การตั้งค่า → เทมเพลต',
    pdf_missing_needs_admin: 'ไม่พบไฟล์ PDF ที่จัดเก็บไว้ กรุณาแจ้งผู้ดูแลระบบหรือเจ้าของให้เปิดสัญญาเช่านี้เพื่อสร้างไฟล์ใหม่',
    unit_required: 'เลือกยูนิตที่ว่างเพื่อดำเนินการต่อ',
    deposit_invoice_exists: 'มีใบแจ้งหนี้เงินประกันสำหรับสัญญาเช่านี้อยู่แล้ว',
    // T149-079 F8 (MON-7): รหัสข้อผิดพลาด 422 ของ POST /api/leases/:id/deposit_invoice
    // ("เรียกเก็บเงินประกัน") เมื่อค่าจองที่จ่ายแล้วและ/หรือเงินประกันที่เก็บไว้ก่อนเริ่มใช้ FlowRent
    // ครอบคลุมเงินประกันทั้งหมดแล้ว จึงไม่มีส่วนที่ต้องเรียกเก็บเพิ่ม
    deposit_already_covered: 'เงินประกันครบตามจำนวนแล้ว ไม่มีส่วนที่ต้องเรียกเก็บเพิ่ม',
    // T149-076 (MON-7 A/C): รหัสข้อผิดพลาด 422 ของ POST /api/leases/:id/deposit_held
    deposit_already_held: 'สัญญาเช่านี้มีการบันทึกเงินประกันที่เก็บไว้ก่อนเริ่มใช้ FlowRent แล้ว',
    deposit_already_collected: 'เงินประกันของสัญญาเช่านี้ถูกเก็บครบแล้ว',
    // EP-136 (T136-024): รหัสข้อผิดพลาด 422 ของ cancel_booking + ขยายวันหมดอายุ
    not_a_booking: 'สัญญาเช่านี้ไม่ใช่การจอง',
    already_ended: 'สัญญาเช่านี้สิ้นสุดไปแล้ว',
    disposition_invalid: 'ตัวเลือกการจัดการค่าจองไม่ถูกต้อง',
    expiry_in_past: 'วันหมดอายุการจองต้องอยู่ในอนาคต',
    // T149-010 (MON-1 Q2): บันทึกรายการริบค่าจองไม่สำเร็จ ระบบยกเลิกการทำรายการทั้งหมด
    // สัญญาเช่าจึงยังคงเป็นการจองแบบร่างและไม่มีการเปลี่ยนแปลงใด ๆ
    booking_forfeiture_journal_failed: 'ไม่สามารถบันทึกรายการริบค่าจองได้ การยกเลิกนี้ไม่ถูกบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุน',
    // T158-009: รหัสข้อผิดพลาด 422 ของ DELETE /api/leases/:id
    lease_not_draft: 'ลบได้เฉพาะสัญญาเช่าที่ยังเป็นร่างเท่านั้น',
    lease_has_invoices: 'สัญญาเช่านี้มีใบแจ้งหนี้แล้ว จึงไม่สามารถลบได้',
  },

  // EP-136 (T136-024): ปุ่มยกเลิกการจอง / ขยายเวลาการจอง บนการ์ดการจองในหน้ารายละเอียดยูนิต
  booking: {
    cancel: {
      action: 'ยกเลิกการจอง',
      title: 'ยกเลิกการจอง',
      deposit_warning: 'การยกเลิกจะปิดสัญญาเช่าฉบับร่างและปล่อยยูนิตกลับสู่สถานะว่าง กรุณาเลือกวิธีจัดการค่าจองที่เก็บไว้แล้ว',
      forfeit_label: 'ริบค่าจอง',
      forfeit_hint: 'เก็บไว้เป็นรายได้ ยูนิตจะถูกปล่อยและสัญญาเช่าฉบับร่างจะสิ้นสุด',
      refund_label: 'คืนค่าจอง',
      refund_hint: 'บันทึกการคืนเงินให้ลูกค้า ยูนิตจะถูกปล่อยและสัญญาเช่าฉบับร่างจะสิ้นสุด',
      revenue_message: 'การดำเนินการนี้จะยกเลิกการจองและปิดสัญญาเช่าฉบับร่าง ค่าธรรมเนียมการจองที่เก็บไว้แล้วถือเป็นรายได้ที่ไม่สามารถคืนได้และจะไม่ถูกย้อนกลับ',
      unpaid_message: 'การดำเนินการนี้จะยกเลิกการจอง ปิดสัญญาเช่าฉบับร่าง และลบใบแจ้งหนี้ค่าจองที่ยังไม่ชำระ ยูนิตจะกลับมาว่างอีกครั้ง',
      success: 'ยกเลิกการจองแล้ว',
    },
    extend: {
      action: 'ขยายเวลาการจอง',
      title: 'ขยายเวลาการจอง',
      date_label: 'วันหมดอายุใหม่',
      date_required: 'กรุณาเลือกวันหมดอายุใหม่',
      date_too_early: 'วันหมดอายุใหม่ต้องอยู่หลังวันหมดอายุปัจจุบัน',
      success: 'ขยายเวลาการจองแล้ว',
    },
  },

  // EP-149 T149-081 (MON-7 D): สรุปเงินประกันที่ถืออยู่ทั้งบัญชี ใกล้หัวข้อรายการ
  // ไม่ใช่รายสัญญาเช่าแบบ deposit_panel ด้านล่าง
  deposits_held_summary: {
    label: 'เงินประกันที่ถืออยู่',
  },

  // EP-130 (T130-011): แผงเงินประกันในหน้ารายละเอียดสัญญาเช่า
  deposit_panel: {
    title: 'เงินประกัน',
    amount_label: 'เงินประกัน',
    billed_label: 'เรียกเก็บแล้ว',
    unbilled: 'ยังไม่ได้เรียกเก็บ',
    status_paid: 'ชำระแล้ว',
    status_pending: 'รอชำระ',
    bill_success: 'สร้างใบแจ้งหนี้เงินประกันแล้ว',
    // EP-136 (T136-025): แถวค่าจอง + การเปลี่ยนป้ายแถว "เรียกเก็บแล้ว" +
    // แถวยอดรวมที่เก็บแล้ว แสดงเฉพาะเมื่อสัญญามีการจอง
    booking_fee_label: 'ค่าจอง',
    remainder_label: 'เรียกเก็บส่วนที่เหลือ',
    collected_of: '{{collected}} จาก {{total}}',
    total_collected_label: 'รวมเก็บแล้ว',
    status_full: 'ครบ',
    status_short: 'ขาด',
    // EP-149 T149-079 (MON-7 C): บันทึกเงินประกันที่เก็บไว้ก่อนใช้ FlowRent
    record_held_before_flowrent: 'บันทึกว่าเก็บเงินประกันแล้ว',
    held_before_flowrent_hint: 'ใช้เมื่อเก็บเงินประกันไว้ก่อนเริ่มใช้ FlowRent',
    held_before_flowrent_amount_label: 'จำนวนที่เก็บไว้',
    held_before_flowrent_date_label: 'วันที่เก็บ',
    held_before_flowrent_success: 'บันทึกเงินประกันที่เก็บไว้แล้ว',
  },

  // EP-130 (T130-012): settlement card on lease detail
  settlement_card: {
    title: 'เคลียร์เงินประกัน',
    never_collected_title: 'ไม่มีเงินประกันที่เก็บไว้ให้เคลียร์',
    never_collected_description: 'สัญญาเช่านี้ยังไม่มีใบแจ้งหนี้เงินประกันที่ชำระแล้ว จึงยังไม่มีรายการให้เคลียร์',
    collected_label: 'เก็บเงินประกันแล้ว',
    deductions_label: 'รายการหักเงิน',
    add_work_order: 'เพิ่มใบสั่งงานย้ายออก',
    record_deduction: 'บันทึกรายการหัก',
    no_deductions: 'ยังไม่มีรายการหัก',
    expense_fallback_label: 'ค่าใช้จ่าย',
    returnable_label: 'จะคืนได้สูงสุด',
    return_deposit: 'คืนเงินประกัน',
    shortfall_message: 'ค่าเสียหายเกินยอดเงินประกัน {{amount}}',
    shortfall_line_description: 'ส่วนต่างเงินประกัน',
    bill_shortfall: 'เรียกเก็บส่วนต่าง',
    returned_label: 'คืนแล้ว',
    remaining_label: 'คงเหลือ',
    cleared_badge: 'เคลียร์เรียบร้อย',
  },

  // Wizard preview
  preview: {
    draft_code: 'ฉบับร่าง',
  },

  // EP85-P3-05: tenant vehicles card on lease detail
  tenant_vehicles: {
    title: 'ยานพาหนะผู้เช่า',
    title_with_count: 'ยานพาหนะผู้เช่า ({{count}})',
    empty: 'ยังไม่มียานพาหนะที่ลงทะเบียน',
    edit_vehicle: 'แก้ไขยานพาหนะ',
    add_vehicle: '+ เพิ่มยานพาหนะ',
    add_vehicle_modal_title: 'เพิ่มยานพาหนะผู้เช่า',
    photo_placeholder: 'ไม่มีรูปภาพ',
  },

  // EP85-P3-06: LPR events card on lease detail
  lpr_events_card: {
    title: 'เหตุการณ์ LPR',
    empty: 'ยังไม่มีเหตุการณ์ LPR สำหรับยานพาหนะเหล่านี้',
    open_log: 'ดูบันทึก LPR →',
    candidate_id: 'รหัสผู้สมัคร',
    score: 'คะแนน',
    direction: 'ทิศทาง',
    status: 'สถานะ',
  },

  // EPV-11: vehicle reassignment section on ended leases
  reassign_vehicles: {
    title: 'ยานพาหนะที่ต้องดำเนินการ',
    description: 'ยานพาหนะเหล่านี้ยังคงเชื่อมกับสัญญาเช่าที่สิ้นสุดแล้ว กรุณาเก็บถาวร มอบหมายใหม่ หรือแปลงเป็นยานพาหนะภายนอก',
    archive: 'เก็บถาวร',
    reassign: 'มอบหมายใหม่',
    convert_to_external: 'แปลงเป็นภายนอก',
    confirm_archive: 'เก็บถาวรยานพาหนะนี้หรือไม่? จะยกเลิกการเชื่อมกับสัญญาเช่าและลูกค้าทั้งหมด',
    reassign_to_lease: 'มอบหมายไปยังสัญญาเช่า',
    assign_customer: 'กำหนดลูกค้า',
    confirm: 'ยืนยัน',
  },
}
